module.exports = ".counter{z-index:1000;font-weight:bold}.dangerCounter{padding-left:0.5rem;padding-right:0.5rem;color:#dc3545}.warningCounter{padding-left:0.5rem;padding-right:0.5rem}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/elements/component.idle/component.idle.sass
// module id = ./src/app/common/elements/component.idle/component.idle.sass
// module chunks = main